import script from "./CarouselProducts.component.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselProducts.component.vue?vue&type=script&setup=true&lang=js"

import "./CarouselProducts.component.vue?vue&type=style&index=0&id=33db91de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33db91de"]])

export default __exports__